// extracted by mini-css-extract-plugin
export default {"cls1":"PXIOw07DQx50DaaVIucy","cls2":"Dn25ZZoAe4_Y27SrH5R7 PXIOw07DQx50DaaVIucy"};